import { tsValidateResult, tsValidateString, tsValidateValue } from '@nu-art/ts-common';
import { smartDocExternalParamType_API, smartDocExternalParamType_FreeText, smartDocExternalParamType_NavigationResponse, smartDocExternalParamType_Order, smartDocParamType_External } from './types.js';
import { Validator_ExternalParam_ParamKey } from './param-key.js';
const Validator_ExternalParam_Base = {
    key: tsValidateString(),
    type: tsValidateValue([smartDocParamType_External]),
};
const Validator_ExternalParam_FreeText = {
    ...Validator_ExternalParam_Base,
    subType: tsValidateValue([smartDocExternalParamType_FreeText]),
};
const Validator_ExternalParam_NavigationResponse = {
    ...Validator_ExternalParam_Base,
    subType: tsValidateValue([smartDocExternalParamType_NavigationResponse]),
};
const Validator_ExternalParam_Order = {
    ...Validator_ExternalParam_Base,
    subType: tsValidateValue([smartDocExternalParamType_Order]),
};
const Validator_ExternalParam_API = {
    ...Validator_ExternalParam_Base,
    subType: tsValidateValue([smartDocExternalParamType_API]),
    paramKey: Validator_ExternalParam_ParamKey,
};
export const Validator_SmartDocExternalParam = (param) => {
    if (!param)
        return 'Did not receive an external parameter to validate';
    switch (param.subType) {
        case smartDocExternalParamType_FreeText:
            return tsValidateResult(param, Validator_ExternalParam_FreeText);
        case smartDocExternalParamType_NavigationResponse:
            return tsValidateResult(param, Validator_ExternalParam_NavigationResponse);
        case smartDocExternalParamType_Order:
            return tsValidateResult(param, Validator_ExternalParam_Order);
        case smartDocExternalParamType_API:
            return tsValidateResult(param, Validator_ExternalParam_API);
        default:
            // @ts-ignore
            return param.subType ? `Unknown param sub-type ${param.subType}` : 'Missing mandatory field';
    }
};
//# sourceMappingURL=validation.js.map